// extracted by mini-css-extract-plugin
export var radioInputRow = "w_tg";
export var radioInputColumn = "w_th";
export var inputOptionRow = "w_qM";
export var inputOptionColumn = "w_qN";